import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../axios";
import { PricingDetails } from "@dune/types";
import { pricingDetailsKeys } from "../mutations/pricing-details.mutations";

const fetchPricingDetailsById = async (
	id: number | string | undefined,
): Promise<PricingDetails | null> => {
	if (id == null) {
		return null;
	}
	const { data } = await privateAxios.get<PricingDetails>(
		`/pricing-details/${id}`,
	);
	return data;
};

export const usePricingDetailsQuery = (id: number | string | undefined) => {
	return useQuery<PricingDetails | null>({
		queryKey: pricingDetailsKeys.detail(id ?? "none"),
		queryFn: () => fetchPricingDetailsById(id),
		enabled: id != null,
	});
};
